export default function Skill(){
    return (
        <section id="skill" className="skill">
            <div className="container-fluid">
                <h1>SKILLS</h1> 
                <div className="row">
                    <div className="col-md-12">
                        <div className="marquee-content images">
                            <div>
                                <img src="images/skills/Html.png" alt="html"/><br/>
                                <p className="html">HTML</p>
                            </div>
                            <div>
                                <img src="images/skills/Css.png" alt="css"/><br/>
                                <p className="css">CSS</p>
                            </div>
                            <div>
                                <img src="images/skills/Js.png" alt="js"/><br/>
                                <p className="js">JavaScript</p>
                            </div>
                            <div>
                                <img src="images/skills/Bootstrap.png" alt="bs"/><br/>
                                <p className="bs">Bootstrap</p>
                            </div>
                            <div>
                                <img src="images/skills/React.png" alt="react"/><br/>
                                <p className="rjs">React</p>
                            </div>
                            <div>
                                <img src="images/skills/Git.png" alt="git"/><br/>
                                <p className="git">Git</p>
                            </div>
                            <div>
                                <img src="images/skills/GitHub.png" alt="gh"/><br/>
                                <p className="github">GitHub</p>
                            </div>
                            <div>
                                <img src="images/skills/Postman.png" alt="pm"/><br/>
                                <p className="pm">Postman</p>
                            </div>
                            <div>
                                <img src="images/skills/Wix.png" alt="wix"/><br/>
                                <p className="wix">Wix</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div><br/>
        </section>
    );
}